import React from 'react';
import { Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import Colors from '../../../themes/Colors';

const AlertChangeAdModalComponent = ({ visible, title, description, onAccept, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel}>
          {t('Cancel')}
        </Button>,
        <Button key="accept" type="primary" onClick={onAccept}>
          {t('Change ad')}
        </Button>
      ]}
      centered
      closable={false}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '25px'
        }}
      >
        <h2 style={{ fontSize: '16px', fontWeight: 'bolder', color: Colors.primaryAccent, textAlign: 'left' }}>
          {title}
        </h2>
        <p style={{ fontWeight: 'bold', textAlign: 'left' }}>{description}</p>
      </div>
    </Modal>
  );
};

export default AlertChangeAdModalComponent;
